import {getConnection} from '../../../_shared/GWTBridge/invoke/procMain';
import {buildServerCall} from '../../../services/wcfService';

export function procUndeleteSaved(type: string, ename: string, name: string) {
    const methodName = 'ProcUndeleteSaved';
    const reason = 'ProcUndeleteSavedReact';
    const parameters = {type: [type], ename: [ename], name: [name]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}

export function procDeleteSaved(type: string, ename: string, name: string) {
    const methodName = 'ProcDeleteSaved';
    const reason = 'ProcDeleteSavedReact';
    const parameters = {type: [type], ename: [ename], name: [name]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}

export function procDisplaySaved(type: string, ename: string, name: string, mode: string) {
    const methodName = 'ProcDisplaySaved';
    const reason = 'ProcNewReportReact';
    const parameters = {type: [type], ename: [ename], name: [name], mode: [mode]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
